import { InfoSet } from "../InfoSets/InfoSet";
import { Device } from "../Core/Device";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { Dictionary } from "../Utils/Dictionary";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface Win32_LogicalDiskEntryJsonWrapper {
//    win32_logical_disk_entry: Win32_LogicalDiskEntryJson;
//}

//export interface Win32_LogicalDiskEntryJson {
//    device_id: string;
//    caption: string;
//    description: string;
//    drive_type: string;
//    file_system: string;
//    free_space: string;
//    name: string;
//    size: string;
//    volume_name: string;
//    volume_serial_number: string;
//}

export class Win32_LogicalDiskEntry implements ObjectSerializer {
    //public static FromJson(json: Win32_LogicalDiskEntryJson): Win32_LogicalDiskEntry {

    //    var result = new Win32_LogicalDiskEntry();

    //    if (json.device_id !== undefined) {
    //        result.DeviceID = json.device_id;
    //    }
    //    if (json.caption !== undefined) {
    //        result.Caption = json.caption;
    //    }
    //    if (json.description !== undefined) {
    //        result.Description = json.description;
    //    }
    //    if (json.drive_type !== undefined) {
    //        result.DriveType = json.drive_type;
    //    }
    //    if (json.file_system !== undefined) {
    //        result.FileSystem = json.file_system;
    //    }
    //    if (json.free_space !== undefined) {
    //        result.FreeSpace = NumberUtils.ToNumber(json.free_space);
    //    }
    //    if (json.install_date !== undefined) {
    //        result.InstallDate = NumberUtils.ToNumber(json.install_date);
    //    }
    //    if (json.name !== undefined) {
    //        result.Name = json.name;
    //    }
    //    if (json.size !== undefined) {
    //        result.Size = NumberUtils.ToNumber(json.size);
    //    }
    //    if (json.status !== undefined) {
    //        result.Status = json.status;
    //    }
    //    if (json.volume_name !== undefined) {
    //        result.VolumeName = json.volume_name;
    //    }
    //    if (json.volume_serial_number !== undefined) {
    //        result.VolumeSerialNumber = json.volume_serial_number;
    //    }

    //    return result;
    //}

    public DeviceID: string;
    public get HasDeviceID() {
        return !!this.DeviceID;
    }

    public Caption: string;
    public get HasCaption() {
        return !!this.Caption;
    }

    public Description: string;
    public get HasDescription() {
        return !!this.Description;
    }

    public DriveType: string;
    public get HasDriveType() {
        return !!this.DriveType;
    }

    public FileSystem: string;
    public get HasFileSystem() {
        return !!this.FileSystem;
    }

    public FreeSpace: number;
    public get HasFreeSpace() {
        return this.FreeSpace > 0;
    }
	// public string FreeSpaceString { get { return StringUtils.MemoryBytesToString(FreeSpace); } }

    public InstallDate: number;
	public get HasInstallDate() {
		return (this.InstallDate !== undefined && this.InstallDate > 0);
    }

    public Name: string;
    public get HasName() {
        return !!this.Name;
    }

    public Size: number;
    public get HasSize() {
        return this.Size > 0;
    }
	// public string SizeString { get { return StringUtils.MemoryBytesToString(Size); } }

    public get Used() {
        var used = this.Size - this.FreeSpace;
        if (used < 0)
            return 0;
        return used;
    }

    public Status: string;
    public get HasStatus() {
        return !!this.Status;
    }

    public VolumeName: string;
    public get HasVolumeName() {
        return !!this.VolumeName;
    }

    public VolumeSerialNumber: string;
    public get HasVolumeSerialNumber() {
        return !!this.VolumeSerialNumber;
    }

    public get IsLocalDisk() {
        if (this.HasDriveType) {
            if (this.DriveType === "3")
                return true;
        }
        return false;
    }

    constructor() {
        this.DeviceID = "";

        this.Caption = '';
        this.Description = '';
        this.DriveType = '';
        this.FileSystem = '';

        this.FreeSpace = 0;
		this.InstallDate = 0;

        this.Name = "";
        this.Size = 0;
        this.Status = "";
        this.VolumeName = "";
        this.VolumeSerialNumber = "";
	}

	public Write(obj: any, context: any): void {
		obj.win32_logical_disk_entry = {};
		obj = obj.win32_logical_disk_entry;

		obj.device_id = this.DeviceID;

		if (this.HasCaption)
			obj.caption = this.Caption;
		if (this.HasDescription)
			obj.description = this.Description;
		if (this.HasDriveType)
			obj.drive_type = this.DriveType;
		if (this.HasFileSystem)
			obj.file_system = this.FileSystem;
		if (this.HasFreeSpace)
			obj.free_space = ValueEncoder.EncodeInteger(this.FreeSpace);
		if (this.HasInstallDate)
			obj.install_date = ValueEncoder.EncodeInteger(this.InstallDate);
		if (this.HasName)
			obj.name = this.Name;
		if (this.HasSize)
			obj.size = ValueEncoder.EncodeInteger(this.Size);
		if (this.HasStatus)
			obj.status = this.Status;
		if (this.HasVolumeName)
			obj.volume_name = this.VolumeName;
		if (this.HasVolumeSerialNumber)
			obj.volume_serial_number = this.VolumeSerialNumber;
	}

	public Read(obj: any, context: any): void {
		if (!obj.win32_logical_disk_entry)
			throw new Error();
		obj = obj.win32_logical_disk_entry;

        if (obj.device_id !== undefined) {
            this.DeviceID = obj.device_id;
        }
        if (obj.caption !== undefined) {
            this.Caption = obj.caption;
        }
        if (obj.description !== undefined) {
            this.Description = obj.description;
        }
        if (obj.drive_type !== undefined) {
            this.DriveType = obj.drive_type;
        }
        if (obj.file_system !== undefined) {
            this.FileSystem = obj.file_system;
        }
		if (obj.free_space !== undefined) {
			this.FreeSpace = ValueEncoder.DecodeInteger(obj.free_space);
        }
        if (obj.install_date !== undefined) {
			this.InstallDate = ValueEncoder.DecodeInteger(obj.install_date);
        }
        if (obj.name !== undefined) {
            this.Name = obj.name;
        }
        if (obj.size !== undefined) {
			this.Size = ValueEncoder.DecodeInteger(obj.size);
        }
        if (obj.status !== undefined) {
            this.Status = obj.status;
        }
        if (obj.volume_name !== undefined) {
            this.VolumeName = obj.volume_name;
        }
        if (obj.volume_serial_number !== undefined) {
            this.VolumeSerialNumber = obj.volume_serial_number;
        }
	}
}


export class Win32_LogicalDiskTable extends InfoSet
{
    //public static FromJson(json: InfoSetEntriesJson<Win32_LogicalDiskEntryJsonWrapper>, device: Device): Win32_LogicalDiskTable {
    //    var result = new Win32_LogicalDiskTable(device);

    //    json.entries.forEach((jsonEntry) => {
    //        var entry = Win32_LogicalDiskEntry.FromJson(jsonEntry.win32_logical_disk_entry);
    //        result.AddLogicalDisk(entry);
    //    });

    //    return result;
    //}

    private _diskTable: Dictionary<string, Win32_LogicalDiskEntry>;

	constructor(device: Device) {
		super(device);
        this._diskTable = new Dictionary<string, Win32_LogicalDiskEntry>();
		return;
	}

	public Add(deviceID: string): Win32_LogicalDiskEntry {
        var diskEntry: Win32_LogicalDiskEntry = this.Find(deviceID);

        if (!diskEntry) {
            diskEntry = new Win32_LogicalDiskEntry();
            this.AddLogicalDisk(diskEntry);
		}

        return diskEntry;
	}

    public AddLogicalDisk(diskEntry: Win32_LogicalDiskEntry): boolean {
        if (!diskEntry.HasDeviceID)
            return false;

		if (!this._diskTable.ContainsKey(diskEntry.DeviceID)) {
            this._diskTable.Add(diskEntry.DeviceID, diskEntry);
			return true;
		}

		return false;
	}

	public Clear():void {
		this._diskTable.Clear();
	}

	public get Count(): number {
		return this._diskTable.Count;
	}

    public Find(deviceID: string): Win32_LogicalDiskEntry {
		return this._diskTable.Item(deviceID);
	}

    public Remove(deviceID: string): boolean {
        return this._diskTable.Remove(deviceID);
	}

    public ForEach(callbackfn: (value: Win32_LogicalDiskEntry, index: number, array: Win32_LogicalDiskEntry[]) => void, thisArg?: any): void {
		this._diskTable.Values().ForEach(callbackfn, thisArg);
	}

    public Some(callbackfn: (value: Win32_LogicalDiskEntry, index: number, array: Win32_LogicalDiskEntry[]) => boolean, thisArg?: any): boolean {
        return this._diskTable.Values().Some(callbackfn, thisArg);
	}

    public Every(callbackfn: (value: Win32_LogicalDiskEntry, index: number, array: Win32_LogicalDiskEntry[]) => boolean, thisArg?: any): boolean {
        return this._diskTable.Values().Every(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		if (this._diskTable.Count > 0) {
			obj.w32_ldsk_info = {};
			obj = obj.w32_ldsk_info;

			obj.entries = [];
			ObjSerUtils.WriteObjSerCollection(obj.entries, this._diskTable.Values(), context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.w32_ldsk_info)
			throw new Error();
		obj = obj.w32_ldsk_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new Win32_LogicalDiskEntry();
				entry.Read(value, context);
				this.AddLogicalDisk(entry);
			}, this);
		}
	}
}
